import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { CallsService } from '../calls.service';
import { CallAttachmentsQuery } from '../../../../generated/graphql';
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';

export interface ViewAttachmentsDialogData {
  callId: number;
}

type AttachmentItem = CallAttachmentsQuery['attachments'][0];

@Component({
  selector: 'app-view-attachments-dialog',
  templateUrl: './view-attachments-dialog.component.html',
})
export class ViewAttachmentsDialogComponent implements OnInit {
  attachments: CallAttachmentsQuery['attachments'] = [];
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ViewAttachmentsDialogData,
    private callsService: CallsService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.callsService.getAttachments(this.data.callId).subscribe(result => {
      this.attachments = result.data.attachments;
      this.loading = false;
    });
  }

  deleteAttachment(attachment: AttachmentItem): void {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: '400px',
        data: {
          title: 'Eliminar documento',
          content: '¿Deseas eliminar este documento? Esta acción no se puede deshacer.',
        },
      })
      .afterClosed()
      .pipe(filter(r => r))
      .subscribe(() => {
        this.callsService.deleteAttachment(this.data.callId, attachment.id).subscribe(() => {
          this.attachments = this.attachments.filter(a => a.id !== attachment.id);
        });
      });
  }
}
